import { Document } from "@react-pdf/renderer";
import PdfSection from "../pdfBuilder/components/layout/PdfSection";
import PdfPageBranded from "../pdfBuilder/pages/PdfPageBranded";
import PdfFundingShieldTable from "./pages/PdfFundingShieldTable";
import { formatDollar } from "../../../utils/numbers/formatDollar";
import { removeEmptyObjectValues } from "../../../_src_shared/utils/objects/removeEmptyObjectValues";

const FundingShieldPDF = ({ formData }) => {
  const convertFundingShieldData = (data) => {
    let convertedData = { ...formData };

    convertedData.totalLoanAmount = formatDollar(formData?.totalLoanAmount);
    return removeEmptyObjectValues(convertedData);
    // return convertedData;
  };
  return (
    <Document>
      <PdfPageBranded
        pageNumber={"1 of 1"}
        pageTitle="Funding Shield"
        date={new Date().toISOString().split("T")[0]}
      >
        <PdfSection>
          <PdfFundingShieldTable data={convertFundingShieldData(formData)} />
        </PdfSection>
      </PdfPageBranded>
    </Document>
  );
};

export default FundingShieldPDF;
